// extracted by mini-css-extract-plugin
export default {"footerText":"SibiFooter_footerText__prs-A","sibiFooter":"SibiFooter_sibiFooter__4GzLb","footerPadding":"SibiFooter_footerPadding__QphzB","navItem":"SibiFooter_navItem__SQKdy"};